import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import SuccessTickIcon from "../../Svg/SuccessTickIcon";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "80%", md: "50%", lg: "30%" },
  height: 330,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
};
export default function BasicModal({ title, msg, open, onClose, action }) {
  return (
    <div>
      {/* <Button onClick={handleOpen}>Open modal</Button> */}

      <Modal
        open={open}
        onClose={onClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        sx={{ borderRadius: "12px" }}
        hideBackdrop={true}
      >
        <Box sx={style}>
          <Box
            height={50}
            display={"flex"}
            justifyContent={"center"}
            alignItems={"center"}
            backgroundColor="#00008B12"
          >
            <Typography variant="h6" id="modal-modal-title">
              {title}
            </Typography>
          </Box>

          <Typography id="modal-modal-title" variant="h6" component="h2">
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                marginTop: "10%",
                marginBottom: "10%",
              }}
            >
              <SuccessTickIcon />
            </Box>
          </Typography>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Typography
              id="modal-modal-description"
              sx={{ mt: 2, paddingX: 1, textAlign: "center" }}
            >
              {msg}
            </Typography>
          </Box>
          {/* <Box sx={{ display: "flex", justifyContent: "center" }}>
            <Typography id="modal-modal-description" sx={{ mt: 2 }}>
              Create Another?
            </Typography>
          </Box> */}
          <Box
            display={"flex"}
            justifyContent={"space-around"}
            marginTop={"10%"}
          >
            <Button  onClick={onClose}>Ok</Button>
            {/* <Button onClick={action}>Yes Continue</Button> */}
          </Box>
        </Box>
      </Modal>
    </div>
  );
}
